import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs'

function IndustrialScanningServices() {
  return (
    <div>
        <Breadcrumbs />
    </div>
  )
}

export default IndustrialScanningServices